import { Text, View } from '@react-pdf/renderer';
import { styles } from '../style/pdfStyles';
import { normalizeValue } from '../utils/normalize';

interface PdfSummaryProps {
  publicInfos?: {
    paragraphs?: Record<string, string>;
    strength?: string[];
    titlets?: string[];
  };
}

export const PdfSummary = ({ publicInfos }: PdfSummaryProps) => {
  const strengths = Array.isArray(publicInfos?.titlets)
    ? publicInfos?.titlets
    : Array.isArray(publicInfos?.strength)
    ? publicInfos?.strength
    : [];

  const formatStrength = (value: string) => {
    const text = normalizeValue(value);
    if (!text || text === '—') return text;
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  const paragraphEntries = Object.entries(publicInfos?.paragraphs || {}).slice(0, 5);

  return (
    <View>
      <Text style={styles.sectionTitle}>Riepilogo</Text>

      <View style={styles.block}>
        <Text style={styles.subtitle}>Punti di forza</Text>
        {strengths.length === 0 ? (
          <Text style={[styles.text, styles.mutedText]}>—</Text>
        ) : (
          strengths.map((item, index) => (
            <View key={`${item}-${index}`} style={styles.listItem}>
              <Text style={styles.bullet}>-</Text>
              <Text style={styles.text}>{formatStrength(item)}</Text>
            </View>
          ))
        )}
      </View>

      <View>
        <Text style={styles.subtitle}>In breve</Text>
        {paragraphEntries.length === 0 ? (
          <Text style={[styles.text, styles.mutedText]}>—</Text>
        ) : (
          paragraphEntries.map(([title, value]) => (
            <View key={title} style={styles.listItem}>
              <Text style={styles.bullet}>-</Text>
              <Text style={styles.text}>
                {title}: {normalizeValue(value)}
              </Text>
            </View>
          ))
        )}
      </View>
    </View>
  );
};
